import { scale } from '@utils/normalize';
import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  adjTooltip: { marginRight: 6, marginVertical: 4 },
  popOverContainer: {
    alignItems: 'center',
    flexDirection: 'row',
    height: 'auto',
    justifyContent: 'space-between',
    paddingHorizontal: scale(10),
    paddingVertical: scale(4),
  },
  textAndCloseParent: {
    flexDirection: 'row',
    flex: 1,
  },
});
export default styles;
